import { render, staticRenderFns } from "./ChatEditor.vue?vue&type=template&id=072794a6&"
import script from "./ChatEditor.vue?vue&type=script&lang=js&"
export * from "./ChatEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports